import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

const EditUstanovaForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [naziv, setNaziv] = useState('');
  const [mjesto, setMjesto] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_CONFIG.ENDPOINTS.USTANOVE}/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Greška prilikom dohvaćanja ustanove.');
        const data = await res.json();
        setNaziv(data.naziv_ustanove || '');
        setMjesto(data.mjesto || '');
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_CONFIG.ENDPOINTS.USTANOVE}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ naziv_ustanove: naziv, mjesto }),
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || 'Greška prilikom ažuriranja.');
      }
      setSuccess('Ustanova je uspješno ažurirana.');
      setTimeout(() => navigate('/ustanove'), 800);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[50vh] text-gray-600">Učitavanje...</div>;
  if (error) return (
    <div className="max-w-md mx-auto p-4">
      <div className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">Greška: {error}</div>
    </div>
  );

  return (
    <div className="max-w-md mx-auto">
      <div className="p-8 bg-white rounded-lg shadow-sm border border-gray-200 w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Uredi ustanovu</h2>
        {success && <div className="p-3 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">{success}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="naziv" className="block text-sm font-medium text-gray-700">Naziv ustanove</label>
            <input id="naziv" type="text" value={naziv} onChange={(e) => setNaziv(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
          </div>
          <div>
            <label htmlFor="mjesto" className="block text-sm font-medium text-gray-700">Mjesto</label>
            <input id="mjesto" type="text" value={mjesto} onChange={(e) => setMjesto(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
          </div>
          <div className="flex gap-2">
            <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors">Sačuvaj</button>
            <button type="button" onClick={() => navigate('/ustanove')} className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition-colors">Otkaži</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUstanovaForm;
